import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=b9467230&scoped=true&"
import script from "./Get.vue?vue&type=script&lang=js&"
export * from "./Get.vue?vue&type=script&lang=js&"
import style0 from "./Get.vue?vue&type=style&index=0&id=b9467230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9467230",
  null
  
)

export default component.exports